import { getData, postData, putData } from 'src/api/http.service';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';
import { getAPIEndpoints, handleApiError } from 'src/utils';

const campaignActionTypes = {
  GET_ALL_CAMPAIGNS: 'GET_ALL_CAMPAIGNS',
  GET_CAMPAIGN_DETAILS: 'GET_CAMPAIGN_DETAILS',
  RESET_CAMPAIGN_DETAILS: 'RESET_CAMPAIGN_DETAILS',
  GET_CATEGORY_STORE_LISTINGS: 'GET_CATEGORY_STORE_LISTINGS',
  SET_CATEGORY_TREE_LOADING: 'SET_CATEGORY_TREE_LOADING',
};

const createCampaign = body => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await postData(`${getAPIEndpoints().createCampaign}`, body);
    dispatch(ApiCallSuccessAction({ message: 'Campaign created successfully' }));
    dispatch(getAllCampaigns());
    return response;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    return err;
  }
};

const editCampaign = body => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await putData(`${getAPIEndpoints().updateCampaign}`, body);

    dispatch(ApiCallSuccessAction({ message: 'Campaign updated successfully' }));
    dispatch(getCampaignByCampaignId(body.campaignId));
    return response;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    return err;
  }
};

const activateCampaign = (campaignId, active, body) => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await putData(
      `${getAPIEndpoints().activateCampaign}`
        .replace('{campaignId}', campaignId)
        .replace('{active}', active),
      body
    );

    dispatch(ApiCallSuccessAction({ message: 'Campaign updated successfully' }));
    dispatch(getAllCampaigns());
    return response;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    dispatch(getAllCampaigns());
    return err;
  }
};
const getAllCampaigns = ({
  page = 0,
  size = 10,
  sort = 'DESC',
  sortBy = 'createdAt',
} = {}) => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await getData(
      `${getAPIEndpoints().campaigns}?page=${page}&size=${size}&sort=${sort}&sortBy=${sortBy}`
    );
    dispatch({ type: campaignActionTypes.GET_ALL_CAMPAIGNS, payload: response.data });
    dispatch(ApiCallSuccessAction({ message: '' }));
    return true;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
  }
};

const getCampaignByCampaignId = campaignId => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await getData(
      `${getAPIEndpoints().campaign}`.replace('{campaignId}', campaignId)
    );
    dispatch({ type: campaignActionTypes.GET_CAMPAIGN_DETAILS, payload: response.data });
    dispatch(ApiCallSuccessAction({ message: '' }));
    return true;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
  }
};
const resetCampaignDetails = () => {
  return dispatch => {
    dispatch({ type: campaignActionTypes.RESET_CAMPAIGN_DETAILS });
  };
};

const getSubcategoryStoreListings = () => async dispatch => {
  dispatch({ type: campaignActionTypes.SET_CATEGORY_TREE_LOADING, payload: true });
  try {
    const response = await getData(`${getAPIEndpoints().subcategoryStoreListings}`);
    const rows = Array.isArray(response.data) ? response.data : response.data.data;
    dispatch({ type: campaignActionTypes.GET_CATEGORY_STORE_LISTINGS, payload: rows });
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
  } finally {
    dispatch({ type: campaignActionTypes.SET_CATEGORY_TREE_LOADING, payload: false });
  }
};

export {
  getAllCampaigns,
  createCampaign,
  editCampaign,
  activateCampaign,
  getCampaignByCampaignId,
  resetCampaignDetails,
  getSubcategoryStoreListings,
  campaignActionTypes,
};
